import {StyleSheet} from 'react-native';
import {colorPalette, textStyles} from '../../../theme';

export default StyleSheet.create({
  errorWrapper: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginHorizontal: 16,
    marginTop: 8,
  },
  errorText: {
    color: colorPalette.errorMain,
    fontSize: 13,
    fontFamily: textStyles.regular,
    marginRight: 4,
  },
});
